const options = {
    estabilidad: [
        {
            value: '0',
            label: 'CASADO CON HIJOS',
        },
        {
            value: '1',
            label: 'PROPIETARIO DE CASA',
        },
        {
            value: '2',
            label: '+2 AÑOS EN LA VIVIENDA',
        },
        {
            value: '3',
            label: '+2 AÑOS COMO PROPIETARIO DEL NEGOCIO',
        },
        {
            value: '4',
            label: '+2 AÑOS CON EL NEGOCIO EN MISMO LUGAR',
        },
    ],
    responsabilidad_pagos: [
        {
            value: '0',
            label: 'PAGO DE CRÉDITO A TIEMPO',
        },
        {
            value: '1',
            label: 'PAGO SERVICIOS PÚBLICOS SIN MORA',
        },
        {
            value: '2',
            label: 'TIENE CRÉDITO CON PROVEEDORES',
        },
    ],
    reputacion: [
        {
            value: '0',
            label: 'RECOMENDADO POR BUEN CLIENTE',
        },
        {
            value: '1',
            label: 'BUENA REPUTACIÓN DE VECINOS',
        },
        {
            value: '2',
            label: 'BUENA REPUTACIÓN PROVEEDORES',
        },
        {
            value: '3',
            label: 'BUENA REPUTACIÓN ARRENDADORES',
        },
    ],
    habilidad_empresarial: [
        {
            value: '0',
            label: 'LIBRO DE COMPRAS Y VENTAS',
        },
        {
            value: '1',
            label: 'NEGOCIO EB ÁREA COMERCIAL',
        },
        {
            value: '2',
            label: 'CRECIMIENTO DEL NEGOCIO',
        },
        {
            value: '3',
            label: 'INGRESOS ADICIONALES',
        },
        {
            value: '4',
            label: 'N° DE EMPLEADOS',
        },
    ],
    dias_Semana: [
        {
            value: '0',
            label: 'LUNES',
        },
        {
            value: '1',
            label: 'MARTES',
        },
        {
            value: '2',
            label: 'MIERCOLES',
        },
        {
            value: '3',
            label: 'JUEVES',
        },
        {
            value: '4',
            label: 'VIERNES',
        },
    ],
};
export default options;
